import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import _ from 'lodash';
import InfluencerContextBar from '../../components/influencer-context-bar';
import AuditLogTable from '../../components/audit-log-table';
import withUserInfo from '../../hocs/has-user-info';
import withOrganisationData from '../../hocs/data/with-organisation-data';
import {
  withDyzioEventsData,
  EVENT_TYPES,
} from '../../hocs/data/with-dyzio-events-data';

const PER_PAGE = 12;

class OrganisationAuditLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shouldRenderLoader: true,
      isLoaded: false,
      hasNextPage: true,
      organisation: null,
      events: [],
      currentOffset: 0,
    };
  }

  componentDidMount() {
    const {
      getOrganisationById,
      userInfo: { organisationId },
    } = this.props;
    const { error } = console;
    getOrganisationById(organisationId).then(organisation => {
      this.setState({
        organisation,
      }, this.fetchEvents);
      return organisation;
    }).catch(error);
  }

  onPageIncrement = () => this.setState({
    currentOffset: _.add(this.state.currentOffset, PER_PAGE),
    shouldRenderLoader: true,
  }, this.fetchEvents);

  onPageDecrement = () => this.setState({
    currentOffset: _.subtract(this.state.currentOffset, PER_PAGE),
    shouldRenderLoader: true,
  }, this.fetchEvents);

  fetchEvents = () => {
    const {
      getDyzioEvents,
      userInfo: { organisationId },
    } = this.props;

    const { currentOffset } = this.state;

    getDyzioEvents({
      filter: {
        organisation: organisationId,
        eventName: [
          EVENT_TYPES.INFLUENCER_CREATED,
          EVENT_TYPES.USER_CREATED,
          EVENT_TYPES.CAMPAIGN_CREATED,
          EVENT_TYPES.SHORTLIST_CREATED,
          EVENT_TYPES.TRACKED_ASSED_CREATED,
          EVENT_TYPES.CAMPAIGN_PERMISSION_CREATED,
          EVENT_TYPES.CAMPAIGN_INVITATION_CREATED,
          EVENT_TYPES.CAMPAIGN_INVITATION_UPDATED,
        ],
      },
      page: {
        limit: PER_PAGE,
        offset: currentOffset,
      },
      sort: '-createdDate',
    }).then(eventRecords => {
      const eventsSize = _.size(eventRecords);
      const shouldDisableNextButton = currentOffset > 0 && eventsSize < PER_PAGE;
      const events = _.isEmpty(eventRecords) && shouldDisableNextButton ? this.state.events : eventRecords;
      this.setState({
        events,
        isLoaded: true,
        shouldRenderLoader: false,
        shouldDisableNextButton,
      });
      return events;
    }).catch(() => {
      this.setState({
        shouldRenderLoader: false,
        events: [],
        isLoaded: false,
        hasNextPage: false,
      });
    });
  }

  render() {
    const {
      organisation,
      isLoaded,
      shouldRenderLoader,
      events,
      currentOffset,
      shouldDisableNextButton,
    } = this.state;

    const tableProps = {
      isLoaded,
      shouldRenderLoader,
      events,
      onPageIncrement: this.onPageIncrement,
      onPageDecrement: this.onPageDecrement,
      currentOffset,
      shouldDisableNextButton,
    };
    return (
      <div className="page">
        {
          organisation &&
          <InfluencerContextBar
            organisationName={organisation.name}
            showTooltip={false}
            rightButtonCallback={null}
            leftButtonLabel=""
            rightButtonLabel=""
            title="Audit Log"
          />
        }
        <div className="page-content">
          <AuditLogTable {...tableProps} />
        </div>
      </div>
    );
  }
}

OrganisationAuditLog.propTypes = {
  userInfo: PropTypes.object.isRequired,
  getOrganisationById: PropTypes.func.isRequired,
  getDyzioEvents: PropTypes.func.isRequired,
};

export default compose(
  withDyzioEventsData,
  withOrganisationData,
  withUserInfo,
)(OrganisationAuditLog);



/** WEBPACK FOOTER **
 ** ./src/containers/organisation-audit-log/index.js
 **/